/**
 * Logo — icône image + texte réel (remplace l'ancien logo tout-image).
 * `variant="footer"` masque le slogan et réduit la taille pour le pied de page.
 */
export default function Logo({ variant = "header" }) {
  const isFooter = variant === "footer";

  return (
    <span className="ds-logo" data-testid={`logo-${variant}`}>
      <picture>
        <source srcSet="/logo-icon.webp" type="image/webp" />
        <img
          src="/logo-icon.png"
          alt=""
          aria-hidden="true"
          className={isFooter ? "ds-logo-icon ds-logo-icon--footer" : "ds-logo-icon"}
          width={34}
          height={61}
        />
      </picture>
      <span className="ds-logo-text">
        <span className={isFooter ? "ds-logo-brand ds-logo-brand--footer" : "ds-logo-brand"}>
          DS Serrurier
        </span>
        {!isFooter && (
          <span className="ds-logo-tagline">
            <span className="ds-logo-tagline-full">Intervention rapide · </span>
            Dépannage 24h/24 &amp; 7j/7
          </span>
        )}
      </span>
    </span>
  );
}
